import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Title} from '../../../../components/title/title';
import {TranslatePipe} from '@ngx-translate/core';
import {TabItem, TabMenu} from '../../../../components/tab-menu/tab-menu';
import {RouterOutlet} from '@angular/router';
import {RouteUri} from '../../../../constants/route-uri';

@Component({
  selector: 'elcia-directory-home',
  imports: [
    Title,
    TranslatePipe,
    TabMenu,
    RouterOutlet
  ],
  templateUrl: './directory-home.html',
  styleUrl: './directory-home.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryHome {

  protected readonly items: TabItem[] = [
    {
      icon: 'building',
      label: 'entity.companies',
      route: RouteUri.DIRECTORY_COMPANIES,
    },
    {
      icon: 'user',
      label: 'entity.contacts',
      route: RouteUri.DIRECTORY_CONTACTS,
    },
  ];

}
